import 'babel-polyfill';
import 'custom-event-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { setLocale } from 'react-redux-i18n-lite';
import DayjsUtils from '@date-io/dayjs';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import * as _ from 'lodash';
import $ from 'jquery';
import dayjs from 'dayjs';

import Routes from './routes';
import * as shared from './shared';
import * as RouteListener from './listeners/route/routeListener';
import * as EventListener from './listeners/event/eventListener';
import { getDefaultLanguage, setTranslations } from './services/translate/translateService';
import { setAccountConfiguration, setUserData } from './actions/accountActions';
import { setContentBookCmi5etags } from './actions/contentActions';
import { configureStore } from './store/configureStore';
import { setRequestInterceptor } from './interceptors/requestService';
import { setResponseInterceptor } from './interceptors/responseService';
import registerServiceWorker from './service-worker/register-sw';
import { initComponentSpecializations } from './components/cross-platform';
import { initActionSpecializations } from './actions/cross-platform/index';
import { applySkin } from './actions/skinActions';
import configuration from './styles/default/configuration.json';
import * as skinUtils from './utils/skinUtils';
import { makeClassroomGTranslateAware } from './utils/gtranslateAware';
import { datadogLogs } from '@datadog/browser-logs';
import {
  DD_CLIENT_ENABLED,
  DD_CLIENT_ENV,
  DD_CLIENT_SAMPLE_RATE,
  DD_CLIENT_SERVICE,
  DD_CLIENT_TOKEN
} from './config_module';
import { isElectronApp } from './services/crossPlatform/crossPlatformService';
import { setDayJsLocale } from './services/translate/dayjsLocaleUpdater';

if (isElectronApp()) {
  require('electron-cookies');
}

if (DD_CLIENT_ENABLED) {
  datadogLogs.init({
    clientToken: DD_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    env: DD_CLIENT_ENV,
    service: DD_CLIENT_SERVICE,
    forwardErrorsToLogs: true,
    sampleRate: parseInt(DD_CLIENT_SAMPLE_RATE)
  });
}

/**
 * Creates the app store de la app add subscribe to the changes in it. If so, it launch an event.
 */
let store = configureStore();
setTranslations(store);
const config = shared.getConfigurationFromStorage() ? JSON.parse(shared.getConfigurationFromStorage()) : configuration;
// Setting up Interceptors
setRequestInterceptor(config.externalLoginURL);
setResponseInterceptor(store);

initComponentSpecializations();
initActionSpecializations();

store.subscribe(() => {
  const state = store.getState();

  shared.languageStorageHandler(state.account.user.language);
  shared.userIdStorageHandler(state.account.user.userId);
  shared.userDataStorageHandler(JSON.stringify(state.account.user));
});

store.dispatch(setLocale(shared.getLanguageFromStorage() || getDefaultLanguage()));
store.dispatch(setAccountConfiguration(config));

setDayJsLocale(shared.getLanguageFromStorage() || getDefaultLanguage());
store.dispatch(setContentBookCmi5etags(shared.getCmi5etagsInStorage()));
if (!_.isNil(shared.getUserDataFromStorage())) {
  store.dispatch(setUserData(shared.getUserDataFromStorage()));
}

store.dispatch(applySkin(skinUtils.getLastOrDefaultSkin()));

// Route Listener
RouteListener.start(store);

// Event Listener
EventListener.start(store);

// https://jira.netexlearning.com/browse/SMARTCLASS-4952
// https://github.com/facebook/react/issues/11538#issuecomment-417504600
makeClassroomGTranslateAware();
// App Styles
require('./styles/app.css');
window.jQuery = $;

render(
  <MuiPickersUtilsProvider utils={DayjsUtils}>
    <Routes store={store} className="app-docker" />
  </MuiPickersUtilsProvider>,
  document.getElementById('app')
);

registerServiceWorker();
